import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaOnboardingBackdrop = styled.div`
  position: fixed;
  inset: 0;
  top: 78px;
  background: #00000080;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: ${prem(20)};
  animation: fadeIn 180ms ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`;

export const TrimaOnboardingCard = styled.div`
  background: var(--ion-background-color, #ffffff);
  border-radius: ${prem(14)};
  padding: ${prem(24)} ${prem(20)};
  max-width: ${prem(360)};
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: ${prem(14)};

  .trima-onboarding-icon {
    font-size: ${prem(36)};
    line-height: 1;
  }

  h2 {
    font-size: ${prem(18)};
    font-weight: 700;
    margin: 0;
    color: var(--ion-text-color);
  }

  p {
    font-size: ${prem(14)};
    line-height: 1.5;
    color: var(--ion-text-color-secondary);
    margin: 0;
  }

  .trima-onboarding-cta {
    margin-top: ${prem(8)};
  }
`;
